// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1zLv6","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1B742"};